/* global __WEB__ */

/**
 * Provides functionality to refresh the page after inactivity.
 *
 * This should only activate for devices which pause the JS-runtime when going inactive.
 * For example when closing Safari on iOS etc.
 * Making the browser tab inactive on a desktop will not halt the JS-runtime, so realtime updates
 * will continue to work, so we don't really need to refresh the page.
 */

/**
 * Sets the threshold for how many minutes we can stay inactive before reloading the page.
 */
const threshold = 10 * 60 * 1000; // Ten minutes

let enabled = false;

// Keep a reference to the current visiblity state
let visibilityState;

// `tick` is an interval.
let tick;

// `Date` for when the last tick occured
let lastTick;

const onTick = () => {
    if (document.visibilityState === 'visible') {
        lastTick = new Date();
    }
};

/**
 * Start a tick by using `setInterval`.
 * We use this to check if the JS-runtime pauses when visibilityState goes to 'hidden'.
 * On devices which pauses the runtime, the `lastTick` will be old, so we know that the runtime
 * was paused when visibilityState goes back to 'visible'.
 */
function startTick() {
    tick = setInterval(onTick, 10 * 1000);
}

function stopTick() {
    clearInterval(tick);
}

const onVisibilityChanged = () => {
    const prevState = visibilityState;

    visibilityState = document.visibilityState;

    // See if we went from a hidden to visible state
    if (prevState === 'hidden' && visibilityState === 'visible') {
        // Stop the tick, so it doesn't itnerfer with the next check.
        stopTick();

        // Check if the last tick occured over twenty (threshold) minutes ago.
        if (new Date() - lastTick > threshold) {
            window.location.reload();
        } else {
            startTick();
        }
    }
};

function enable() {
    if (enabled) {
        return;
    }

    enabled = true;

    document.addEventListener('visibilitychange', onVisibilityChanged, true);
    startTick();
}

function disable() {
    if (!enabled) {
        return;
    }

    document.removeEventListener('visibilitychange', onVisibilityChanged, true);
    stopTick();
}

export default function refreshAfterInactivity(flag = true) {
    if (__WEB__) {
        if ('visibilityState' in document) {
            if (flag) enable();
            else disable();
        }
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/service/refreshAfterInactivity.js
 **/